<template>
    <el-dialog title="导出数据筛选" width="50%"
               :close-on-click-modal="false"
               append-to-body :visible.sync="visible"
               v-if="visible">
        <div class="tips">勾选后，仅导出所选字段数据；未勾选，导出全部字段数据。</div>
        <el-transfer class="exportTransfer" filterable
                     ref="transfer"
                     v-model="selId"
                     :titles="['选择数据', '已选数据']"
                     target-order="push"
                     :props="{key: 'basicId',label: 'basicName'}"
                     :data="transferData" v-loading="loading">
            <div class="pointer basicName" slot-scope="{ option }">
                {{ option.basicName }}
            </div>
        </el-transfer>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" :disabled="loading" @click="doSubmit()" v-noMoreClick>导出</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import Sortable from 'sortablejs'

    export default {
        data() {
            return {
                visible: false,
                loading: false,
                configId: '',
                basicDataId: '',
                basicDataName: '',
                selId: [],
                selVal: [],
                transferData: [],
                idList: [],
                searchForm: {},
                exportApi: '',
                businessName: '',
                businessInfo: {},
            }
        },
        methods: {
            // configId业务配置id，basicDataId模板id，idList列表选择的数据id集合，name模板名称，searchForm查询条件, exportApi导出接口,
            // businessName业务名称（subForm子表单）
            // businessInfo业务参数
            init(configId, basicDataId, idList, name, searchForm, exportApi, businessName, businessInfo) {
                this.selId = []
                this.selVal = []
                this.configId = configId
                this.basicDataId = basicDataId
                this.idList = idList
                this.basicDataName = name || '导出数据'
                this.searchForm = searchForm || {}
                this.exportApi = exportApi || ''
                this.businessName = businessName || ''
                this.businessInfo = businessInfo || {}
                this.visible = true
                this.$nextTick(() => {
                    this.getExportField()
                    this.initSortable()
                })
            },
            // 获取导出字段
            getExportField() {
                this.loading = true
                this.$axios(this.api.metadata.exportFieldList, {
                    configId: this.configId,
                    basicDataId: this.basicDataId
                }).then(data => {
                    if (data.status) {
                        this.transferData = data.data
                    } else {
                        this.$message.error('查询失败')
                    }
                    this.loading = false
                })
            },
            // 初始化拖拽排序
            initSortable() {
                const that = this
                const transfer = this.$refs.transfer.$el
                const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1].getElementsByClassName('el-transfer-panel__body')[0]
                const rightEl = rightPanel.getElementsByClassName('el-transfer-panel__list')[0]
                Sortable.create(rightEl, {
                    onEnd({ newIndex, oldIndex }) {
                        that.selId.splice(newIndex, 0, that.selId.splice(oldIndex, 1)[0])
                        const newArray = that.selId.slice(0)
                        that.selId = []
                        that.$nextTick(function () {
                            that.selId = newArray
                        })
                    }
                })
            },
            doSubmit() {
                this.selVal = []
                if (this.selId.length) {
                    this.selId.map(id => {
                        this.transferData.map(item => {
                            if (id == item.basicId) {
                                this.pushField(item)
                            }
                        })
                    })
                } else {
                    this.transferData.map(item => {
                        this.pushField(item)
                    })
                }
                this.$nextTick(() => {
                    let url = this.exportApi ? this.exportApi : this.api.metadata.batchExport
                    let data = {
                        fileName: this.basicDataName,
                        basicDataId: this.basicDataId,
                        configId: this.configId,
                        dataId: this.idList,
                        exportFileds: this.selVal,
                        selectArchivesDataElasticsearch: this.searchForm
                    }
                    if (this.businessName == 'subForm') {
                        data = {
                            basicCode: this.businessInfo.basicCode || '',
                            dataId: this.idList,
                            exportFileds: this.selVal,
                            fileName: this.basicDataName,
                            id: this.businessInfo.id || '',
                        }
                    }
                    this.exportExcel(url, data, this.basicDataName, 'post')
                    this.$nextTick(() => {
                        this.visible = false
                    })
                })
            },
            pushField(item) {
                this.selVal.push(item)
            },
        }
    }
</script>

<style scoped lang="scss">
    .el-transfer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .el-transfer > > > .el-transfer-panel {
        width: 32% !important;
    }

    .tips {
        font-size: 12px;
        color: #9e9e9e;
        margin-bottom: 10px;
        padding-left: 40px;
    }

    .basicName {
        padding-left: 6px;
    }

    .basicName:hover {
        background: #F8F4EF !important;
    }
</style>
